import { spaceMixin } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledDivPreviewItem = styled.div`
  &:not(:last-child) {
    margin-bottom: ${spaceMixin('sm')};
  }
`;
